import React from "react";
import Modal from "react-responsive-modal";
import 'react-responsive-modal/styles.css'; 
import './style.css'
const ReactModal = ({ open,onClose,title,children , modalSize="650px" }) => {
  return (
   <Modal open={open} onClose={onClose} center
   classNames={{
    modal: 'react-modal',
  }}
  // styles={{maxWidth : modalSize}}
  closeIcon={<></>}
  >

<div class="card">
  <div class="card-header">
   <span className="react-modal-title">{title}</span> 
   <span className="react-modal-close" onClick={onClose}> <i class="fa fa-times"></i></span>
  </div>
  <div class="card-body">
    {children}
  </div>
</div>

   </Modal>
  );
};

export default ReactModal;
